// src/utils/clipboard.ts

/**
 * Copy text to the clipboard.
 *
 * Prefers the async Clipboard API and falls back to the legacy
 * `document.execCommand('copy')` path (hidden textarea) for older
 * browsers or non-secure contexts.
 *
 * @returns true when the copy succeeded.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Clipboard API refused (permissions, insecure context) — try the fallback.
  }

  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}
